import { Box, Link, Stack } from "@mui/material";

export const PAYMENT_BADGES = {
    secure: [
        { file: "pay_visa_secure.svg", alt: "Visa Secure", href: "https://rs.visa.com/pay-with-visa/security-and-assistance/protected-everywhere.html" },
        { file: "pay_mastercard_id.svg", alt: "Mastercard ID Check", href: "https://www.mastercard.rs/sr-rs/korisnici/pronadite-karticu.html" },
    ],
    processor: [
        { file: "pay_chip_card.svg", alt: "Chip Card", href: "https://chipcard.rs/e-commerce" },
    ],
    cards: [
        { file: "pay_visa.svg", alt: "Visa" },
        { file: "pay_dinacard.svg", alt: "DinaCard" },
        { file: "pay_maestro.svg", alt: "Maestro" },
        { file: "pay_mastercard.svg", alt: "Mastercard" },
    ],
};

export function PayBadge({ file, alt, href }) {
    const img = (
        <Box
            sx={{
                bgcolor: "#fff",
                borderRadius: 1,
                px: 1,
                py: 0.5,
                display: "inline-flex",
                alignItems: "center",
            }}
        >
            <Box
                component="img"
                src={`${process.env.PUBLIC_URL || ""}/assets/payments/${file}`}
                alt={alt}
                sx={{ height: 24, width: "auto", display: "block" }}
            />
        </Box>
    );

    return href ? (
        <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={alt}
            sx={{ display: "inline-flex", transition: "opacity 0.2s", "&:hover": { opacity: 0.8 } }}
        >
            {img}
        </Link>
    ) : (
        <Box sx={{ display: "inline-flex" }}>{img}</Box>
    );
}

// Svi bedževi u jednom redu — za checkout stranicu (unos platne kartice).
export default function PaymentBadges(props) {
    const all = [...PAYMENT_BADGES.secure, ...PAYMENT_BADGES.processor, ...PAYMENT_BADGES.cards];
    return (
        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap justifyContent="center" {...props}>
            {all.map((b) => (
                <PayBadge key={b.file} {...b} />
            ))}
        </Stack>
    );
}
